import React from "react"
import { AgreementProvider } from "./src/context/global-agreement-context"
import { PreloaderProvider } from "./src/context/global-preloader-context"
import { GlobeloaderProvider } from "./src/context/globe-loader-context"

export const wrapRootElement = ({ element }) => {
  return <AgreementProvider><GlobeloaderProvider><PreloaderProvider>{element}</PreloaderProvider></GlobeloaderProvider></AgreementProvider>
}